import cx from 'classnames';

import {Card, Icon, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {CelebrationCardProps} from './CelebrationCard.types';

function getHeader({isFirstCheckIn = false, streakCount = 0, percentage = 0}) {
  if (isFirstCheckIn) {
    return '1st check-in complete!';
  }

  if (percentage === 100) {
    return 'Perfect score!';
  }

  if (streakCount > 1) {
    return 'Check-in streak!';
  }

  return `${Math.round(percentage)}% positive habits!`;
}

function getIconName({isFirstCheckIn = false, streakCount = 0, percentage = 0}) {
  if (isFirstCheckIn) {
    return 'Sparkle';
  }

  if (percentage === 100) {
    return 'Trophy';
  }

  if (streakCount > 1) {
    return 'FireSimple';
  }

  return 'ThumbsUp';
}

function getLede({isFirstCheckIn = false, streakCount = 0, percentage = 0}) {
  if (isFirstCheckIn) {
    return 'Now it’s just rinse and repeat every week to help you stay on track';
  }

  if (percentage === 100) {
    return 'You answered yes to all your action items this week';
  }

  if (streakCount > 1) {
    return `You’ve consistently checked in ${streakCount} weeks in a row`;
  }

  return `You answered yes to ${Math.round(percentage)}% of your action items this week`;
}

/**
 * This component renders one of a number of possible cards for highlighting a
 * user's achievements, based on their answers to a checkIn, and if they have
 * submitted checkIns previously.
 */
export const CelebrationCard = ({
  className,
  isFirstCheckIn = false,
  streakCount = 0,
  percentage = 0,
  ...otherProps
}: CelebrationCardProps) => {
  const shouldRender = isFirstCheckIn || streakCount > 1 || percentage > 60;

  return shouldRender ? (
    <Card
      className={cx(sprinkles({flex: 'flex', gap: 14, p: [16, 20]}), className)}
      variant="white"
      {...otherProps}>
      <span
        className={sprinkles({
          bg: 'faintRed',
          flex: 'flex',
          placeContent: 'center',
          placeItems: 'center',
          radius: 'circle',
          shrink: 0,
          size: [32, 56],
        })}>
        <Icon color="burgundy" name={getIconName({isFirstCheckIn, streakCount, percentage})} />
      </span>

      <div className={sprinkles({flex: 'flex', dir: 'col', gap: 4})}>
        <Text as="h4" color="deepBurgundy" fontWeight="semiBold">
          {getHeader({isFirstCheckIn, streakCount, percentage})}
        </Text>

        <Text as="p" color="mineShaft" variant="caption">
          {getLede({isFirstCheckIn, streakCount, percentage})}
        </Text>
      </div>
    </Card>
  ) : null;
};
